import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import {compose} from 'redux'
import {addImageToAnswer, removeImageFromAnswer} from 'ag-common/tools/imageQuestionAnswer'
import Api from '#services/api'
import {withAnswer} from '#components/HOC/withAnswerHOC'
import Error from '#components/a/Error'
import IconText from '#components/a/IconText'
import Upload from '#components/a/form/Upload'
import UserImage from '#components/m/UserImage'
import QuestionDescription from './QuestionDescription'

export class QuestionImageUpload extends React.Component {
  defaultAnswer = {file: undefined}

  acceptedMimeTypes = ['image/jpeg', 'image/png']

  constructor(props) {
    super(props)
    this.state = {
      isUploading: false,
      error: undefined,
    }
  }

  onChangeFile = async e => {
    const currentAnswer = this.getCurrentAnswer()
    if (e.target.files[0].size > 50000000) {
      this.setState({error: i18n.t('api_upload_file_too_big')})
      return
    }
    if (this.acceptedMimeTypes.indexOf(e.target.files[0].type) === -1) {
      this.setState({error: i18n.t('api_upload_file_mediatype_mismatch')})
      return
    }

    this.setState({isUploading: true, error: undefined})

    try {
      const file = await Api.uploadFile(e.target.files[0])
      const answer = addImageToAnswer(currentAnswer, file)
      this.props.saveAnswer(answer)
    } catch (error) {
      this.setState({error: i18n.t(error.message)})
    }
    this.setState({isUploading: false})
  }

  deleteImage = async blobId => {
    const {deleteImage, currentAnswer} = this.props
    try {
      const model = {
        blobId,
      }
      const answer = removeImageFromAnswer(currentAnswer, blobId)
      this.props.saveAnswer(answer)

      await deleteImage(model)
    } catch (error) {
      this.setState({error: i18n.t(error.message)})
    }
  }

  getCurrentAnswer = () => {
    const {currentAnswer} = this.props
    return currentAnswer && currentAnswer.file ? currentAnswer : this.defaultAnswer
  }

  renderImage = currentAnswer => {
    if (currentAnswer === this.defaultAnswer) {
      return null
    }

    let images = []
    const filesExist = currentAnswer.files && currentAnswer.files.length > 0
    if (filesExist) {
      images = currentAnswer.files
    } else {
      images = [currentAnswer.file]
    }
    const {isReadOnly} = this.props
    return images.map(img => (
      <div key={img.blobId}>
        {!isReadOnly && (
          <div className="userimage_delete">
            <IconText
              icon="delete"
              event={() => this.deleteImage(img.blobId)}
              modifier="grey delete"
              text={i18n.t('Löschen')}
            />
          </div>
        )}
        <UserImage {...img} />
      </div>
    ))
  }

  renderImageUpload = () => {
    const {isUploading} = this.state
    const isEditable = !this.props.isReadOnly
    return isEditable ? (
      <Upload
        onChangeHandle={this.onChangeFile}
        accept={this.acceptedMimeTypes.join(',')}
        labelText="+ Bild hinzufügen"
        isUploading={isUploading}
      />
    ) : null
  }

  render() {
    const {question} = this.props
    const error = this.state.error || this.props.error

    const currentAnswer = this.getCurrentAnswer()

    return (
      <>
        {this.props.children}
        <QuestionDescription question={question} />
        {this.renderImage(currentAnswer)}
        {this.renderImageUpload()}
        {error && <Error text={error} />}
      </>
    )
  }
}

QuestionImageUpload.propTypes = {
  saveAnswer: PropTypes.func.isRequired,
  deleteImage: PropTypes.func.isRequired,
  currentAnswer: PropTypes.object,
  question: PropTypes.object,
  error: PropTypes.string,
  isReadOnly: PropTypes.bool,
  children: PropTypes.node,
}

function mapDispatchToProps() {
  return {
    deleteImage: payload => actions.ausbildungsplan.deleteImage(payload),
  }
}

const enhance = compose(withAnswer, connect(mapDispatchToProps))

export default enhance(QuestionImageUpload)
